import React, { useState, useEffect, useRef } from 'react';
import { useAutocomplete } from '@/hooks/useAutocomplete';

interface OriginSectionProps {
  formData: {
    provenance: string;
    connaissement: string;
  };
  onInputChange: (field: string, value: any) => void;
}

const OriginSection: React.FC<OriginSectionProps> = ({ formData, onInputChange }) => {
  const { values, loading } = useAutocomplete('provenance');
  const datalistId = 'provenance-list';
  const inputRef = useRef<HTMLInputElement>(null);

  const handleProvenanceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onInputChange('provenance', e.target.value);
  };

  const handleProvenanceBlur = () => {
    // Sauvegarder la valeur si elle n'est pas vide
    if (formData.provenance && formData.provenance.trim()) {
      // La sauvegarde sera gérée après l'enregistrement de la pesée
    }
  };

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
      <h3 className="font-medium text-blue-900 text-sm mb-3">PROVENANCE</h3>
      
      <div className="space-y-3">
        <div>
          <label className="block text-sm font-medium text-blue-800 mb-1">Provenance</label>
          <input
            ref={inputRef}
            type="text"
            list={datalistId}
            value={formData.provenance}
            onChange={handleProvenanceChange}
            onBlur={handleProvenanceBlur}
            placeholder="Lieu de provenance"
            className="w-full px-3 py-2 border border-blue-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm bg-white"
            disabled={loading}
          />
          <datalist id={datalistId}>
            {values.map((value, index) => (
              <option key={index} value={value} />
            ))}
          </datalist>
          {loading && (
            <div className="mt-1 text-xs text-gray-500">Chargement des suggestions...</div>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-blue-800 mb-1">Connaissement</label>
          <input
            type="text"
            value={formData.connaissement}
            onChange={(e) => onInputChange('connaissement', e.target.value)}
            placeholder="Numéro de connaissement"
            className="w-full px-3 py-2 border border-blue-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm bg-white"
          />
        </div>
      </div>
    </div>
  );
};

export default OriginSection;
